import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
// material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import Search from '@material-ui/icons/Search';
import { Grid } from '@material-ui/core';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';

import { FaEdit, FaPlus, FaFileExport } from 'react-icons/fa';
import { MdCheckCircle, MdRemoveCircle } from 'react-icons/md';
import { CSVLink } from 'react-csv';

import { changeStatus } from './mutation';
import { getAllPromotions } from './queries';
import { Dialog } from '../../../../components';
import CustomInput from '../../../../components/CustomInput/CustomInput';
import styles from './styles';
import { colors } from '../../../../constants';
import config from '../../../../config';

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);


class TablePromotion extends Component {
  state={
    open: false,
    title: '',
    content: '',
    search: '',
    page: 0,
    limit: 15,
    fromDate: null,
    toDate: null,
  }

  onChangeStatus = (row) => {
    const { id } = row;
    const { changeStatus } = this.props;
    changeStatus({
      variables: {
        id,
      },
      refetchQueries: [{ query: getAllPromotions }],
    }).then((res) => {
      if (res) this.setState({ open: true, content: 'Completed', title: `${row.active ? 'Active' : 'Deactive'} Promotion Code` });
    }).catch(({ graphQLErrors }) => {
      if (graphQLErrors) {
        this.setState({ open: true, content: graphQLErrors[0].message, title: `Erros ${row.active ? 'Active' : 'Deactive'} Promotion Code` });
      }
    });
  }

  onOk = () => {
    this.setState({ open: false });
  }

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value });
  }

  resetFilters = () => {
    this.setState({
      search: '',
      fromDate: null,
      toDate: null,
      page: 0,
    });
  }

  prepareDataForCSV = () => {
    const { getAllPromotions } = this.props;
    let promotions = getAllPromotions || [];
    promotions = _.orderBy(promotions, obj => obj.id, 'desc');
    const { search, fromDate, toDate } = this.state;
    
    // Apply same filters as in render
    if (search) {
      promotions = _.filter(promotions, function (obj) {
        const codeMatch = obj.code ? obj.code.toLowerCase().match(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        const usageMatch = obj.usages && obj.usages.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return codeMatch || consumerUsernameMatch || usageMatch;
      });
    }
    
    // Expand promotions to show one row per usage (same as in render)
    let data = [];
    promotions.forEach(promotion => {
      if (promotion.usages && promotion.usages.length > 0) {
        promotion.usages.forEach(usage => {
          const date = usage.usedAt ? moment(usage.usedAt) : null;
          data.push({
            Code: promotion.code || '',
            Username: promotion.consumer ? promotion.consumer.username : '',
            'Used By': usage.username || '',
            Date: date ? date.format('MM/DD/YYYY HH:mm') : '',
            Active: promotion.active ? 'Yes' : 'No',
            usageDate: usage.usedAt,
          });
        });
      } else {
        // If no usages, still include the promotion code
        data.push({
          Code: promotion.code || '',
          Username: promotion.consumer ? promotion.consumer.username : '',
          'Used By': '',
          Date: '',
          Active: promotion.active ? 'Yes' : 'No',
          usageDate: null,
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(obj.usageDate).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }
    
    // Sort by date descending (most recent first)
    data = _.orderBy(data, obj => {
      if (obj.Date) {
        return moment(obj.Date, 'MM/DD/YYYY HH:mm').valueOf();
      }
      return 0;
    }, 'desc');
    
    // Remove usageDate from CSV export (keep it only for filtering)
    return data.map(({ usageDate, ...rest }) => rest);
  };

  onExportToCSV = () => {
    if (this.csvLinkRef) {
      this.csvLinkRef.link.click();
    }
  }

  render() {
    const { classes, getAllPromotions } = this.props;
    let promotions = getAllPromotions || [];
    promotions = _.orderBy(promotions, obj => obj.id, 'desc');
    const {
      title, content, open, search, page, limit, fromDate, toDate,
    } = this.state;
    
    // Filter promotions
    if (search) {
      promotions = _.filter(promotions, function (obj) {
        const codeMatch = obj.code ? obj.code.toLowerCase().match(search.toLowerCase()) : false;
        const consumerUsername = obj.consumer && obj.consumer.username ? obj.consumer.username.toLowerCase() : '';
        const consumerUsernameMatch = consumerUsername ? consumerUsername.includes(search.toLowerCase()) : false;
        // Also search in usages
        const usageMatch = obj.usages && obj.usages.some(usage => 
          usage.username && usage.username.toLowerCase().includes(search.toLowerCase())
        );
        return codeMatch || consumerUsernameMatch || usageMatch;
      });
    }
    
    // Expand promotions to show one row per usage
    let data = [];
    promotions.forEach(promotion => {
      if (promotion.usages && promotion.usages.length > 0) {
        // Create a row for each usage
        promotion.usages.forEach(usage => {
          data.push({
            ...promotion,
            usageUsername: usage.username,
            usageDate: usage.usedAt,
            isUsageRow: true
          });
        });
      } else {
        // If no usages, show one row with empty usage data
        data.push({
          ...promotion,
          usageUsername: '',
          usageDate: null,
          isUsageRow: false
        });
      }
    });
    
    // Filter by date range (after expanding to rows)
    if (fromDate || toDate) {
      data = _.filter(data, function (obj) {
        if (!obj.usageDate) return false;
        const usageDate = moment(obj.usageDate).startOf('day');
        if (fromDate) {
          const from = moment(fromDate).startOf('day');
          if (usageDate.isBefore(from)) {
            return false;
          }
        }
        if (toDate) {
          const to = moment(toDate).startOf('day');
          if (usageDate.isAfter(to)) {
            return false;
          }
        }
        return true;
      });
    }
    
    // Sort by date descending (most recent first)
    data = _.orderBy(data, obj => {
      if (obj.usageDate) {
        return moment(obj.usageDate).valueOf();
      }
      return 0;
    }, 'desc');
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div>
          <Dialog
            title={title}
            content={content}
            open={open}
            onOk={() => this.onOk()}
          />
          <div className={classes.searchWrapper}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <CustomInput
                formControlProps={{
                  className: `${classes.margin} ${classes.search}`,
                }}
                inputProps={{
                  value: search,
                  onChange: this.onSearch,
                  placeholder: 'Search',
                  inputProps: {
                    'aria-label': 'Search',
                  },
                }}
              />
              <Button aria-label="edit" disabled>
                <Search />
              </Button>
              <Link to={{ pathname: '/addPromotionCode' }}>
                <Button aria-label="Add">
                  <FaPlus color={colors.parimary} size={16} />
                </Button>
              </Link>
              <Button variant="contained" color="primary" className={classes.button} onClick={this.onExportToCSV}>
                <Typography component="p" className={classes.text}>Export</Typography>
                <FaFileExport color="#ffffff" size={16} />
              </Button>
              <CSVLink
                data={this.prepareDataForCSV()}
                filename={`promotions-${moment().format('YYYY-MM-DD-HHmmss')}.csv`}
                style={{ display: "none" }}
                ref={(r) => this.csvLinkRef = r}
              >
                Export
              </CSVLink>
            </div>
            <Typography component="p" style={{ fontSize: '14px', alignSelf: 'center' }}>
              Rows: {data.length}
            </Typography>
          </div>
          <div>
            <Typography variant="body1" style={{ marginTop: '16px', marginBottom: '8px', fontWeight: 500 }}>Date Filter</Typography>
            <Grid key="date-filter" container>
              <Grid key="from" container item xs={12} md={8}>
                <Grid item xs={12} sm={6}>
                  <InlineDatePicker
                    label="From"
                    id="date-from"
                    onChange={(date) => this.setState({ fromDate: date })}
                    format="yyyy-MM-dd"
                    value={this.state.fromDate}
                  />
                </Grid>
                <Grid key="to" item xs={12} sm={6}>
                  <InlineDatePicker
                    label="To"
                    id="date-to"
                    onChange={(date) => this.setState({ toDate: date })}
                    format="yyyy-MM-dd"
                    value={this.state.toDate}
                  />
                </Grid>
              </Grid>
              <Grid key="reset-date-filter" container item xs={12} md={4}>
                <Button variant="contained" color="primary" className={classes.button} onClick={this.resetFilters}>
                  Reset
                </Button>
              </Grid>
            </Grid>
          </div>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell>Code</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Username</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Used By</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Date</CustomTableCell>
                <CustomTableCell align="right" className={classes.columnRow}>Active</CustomTableCell>
                <CustomTableCell align="right" className={classes.rowEdit}>Edit</CustomTableCell>
                <CustomTableCell align="center" className={classes.rowEdit}>Active/Deactive</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(page * limit, page * limit + limit).map((row, index) => {
                return (
                  <TableRow className={classes.row} key={`${row.id}-${row.usageUsername}-${index}`}>
                    <CustomTableCell component="th" scope="row">
                      {row.code}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.consumer ? row.consumer.username : ''}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageUsername || '-'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {row.usageDate ? moment(row.usageDate).format('MM/DD/YYYY HH:mm') : '-'}
                    </CustomTableCell>
                    <CustomTableCell align="right" className={classes.colTable}>
                      {
                        row.active ? <MdCheckCircle color={colors.dark} size={16} /> : <MdRemoveCircle color={colors.red} size={16} />
                      }
                    </CustomTableCell>
                    <CustomTableCell align="center" className={classes.columCenter}>
                      <Link to={{ pathname: `/detailPromotionCode/${row.id}` }}>
                        <Button variant="contained" color="primary" className={classes.button}>
                          <Typography component="p" className={classes.text}>Edit</Typography>
                          <FaEdit color="#ffffff" size={16} />
                        </Button>
                      </Link>
                    </CustomTableCell>
                    <CustomTableCell align="center" className={classes.columCenter}>
                      {
                        !row.active
                          ? (
                            <Button variant="contained" color="primary" className={classes.buttonActive} onClick={() => this.onChangeStatus(row)}>
                              <Typography component="p" className={classes.text}>Activate</Typography>
                            </Button>
                          )
                          : (
                            <Button variant="contained" color="primary" className={classes.buttonDeactive} onClick={() => this.onChangeStatus(row)}>
                              <Typography component="p" className={classes.text}>Deactivate</Typography>
                            </Button>
                          )
                      }
                    </CustomTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={data.length}
            rowsPerPage={limit}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

// Mark: default props
TablePromotion.defaultProps = {
  classes: {},
  getAllPromotions: [],
  changeStatus: () => {},
};

// Mark: PropsType
TablePromotion.propTypes = {
  classes: PropTypes.object,
  getAllPromotions: PropTypes.array,
  changeStatus: PropTypes.func,
};

// Mark: Map data grapql to props
const ListAll = graphql(getAllPromotions, {
  props: ({ data }) => ({
    loading: data.loading,
    getAllPromotions: data.getAllPromotions,
  }),
});

const ChangeStatus = graphql(changeStatus, { name: 'changeStatus' });

export default withStyles(styles)(compose(ListAll, ChangeStatus)(TablePromotion));
